export default "__VITE_ASSET__KwvS6SGE__"